export class BookingResponse {

  public successful?: boolean;
  public reference?: string;
}
